import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function FrontHero() {
  const user = useSelector((state) => state.user.user);
  return (
    <section className="pt-4 pt-md-11 bg-nepal-map">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-5 col-lg-6 order-md-2">
            <img
              src="/assets/img/illustrations/illustration-2.webp"
              className="img-fluid mw-md-150 mw-lg-130 mb-6 mb-md-0"
              alt="..."
              data-aos="fade-up"
              data-aos-delay={200}
              data-aos-duration="800"
              style={{ width: '90%' }}
            />
          </div>
          <div
            className="col-12 col-md-7 col-lg-6 order-md-1"
            data-aos="fade-up"
            data-aos-delay={200}
            data-aos-duration="800">
            <h1 className="display-3 text-center text-md-start">
              <FormattedMessage id="front.herosection_title" />
              <br />
              <span className="text-primary">
                <FormattedMessage id="front.herosection_orgname" />
              </span>
              <br />
            </h1>
            <p className="lead text-center text-md-start mb-6 mb-lg-8">
              <FormattedMessage id="front.herosection_slogan" />
            </p>
            <div className="text-center text-md-start">
              {user ? (
                ''
              ) : (
                <Link to={'/trainees/apply'} className="btn btn-primary shadow lift me-1">
                  <FormattedMessage id="front.herosection_signinbtn" />
                  <i className="fe fe-arrow-right d-none d-md-inline ms-3" />
                </Link>
              )}
              <a href="#" className="btn btn-primary-soft lift">
                <FormattedMessage id="front.herosection_learnmorebtn" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
